export var SIGNUP_EMAIL_KEY = 'tp-signup-email';
export var PathEnum;
(function (PathEnum) {
    PathEnum["LOGIN"] = "./login";
    PathEnum["SIGNUP"] = "./signup";
})(PathEnum || (PathEnum = {}));
